package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AnimationDirection
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme
val HeroDonateStyle = CssStyle {
    base {
        Modifier
            .padding(topBottom = 5.px, leftRight = 30.px)
            .border(1.px, LineStyle.Solid, Colors.Black)
            .borderRadius(5.px)
            .boxShadow(blurRadius = 5.px, spreadRadius = 3.px, color = Colors.DarkGray)
            .backgroundColor(Colors.White) // IMPORTANT FIX
            .cursor(Cursor.Pointer) // IMPORTANT FIX
            .transition(
                Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
            .animation(
                WobbleKeyframes.toAnimation(
                    duration = 2.s,
                    iterationCount = AnimationIterationCount.Infinite,
                    timingFunction = AnimationTimingFunction.cubicBezier(0.4, 0.0, 0.2, 1.0),
                    direction = AnimationDirection.Alternate
                )
            )
    }

    hover {
        Modifier
            .backgroundColor(HLDITheme.Colors.accent)
            .color(HLDITheme.Colors.primary)
            .boxShadow(blurRadius = 10.px, spreadRadius = 16.px, color = Colors.Gray) // visual feedback
    }
}